import { Injectable, inject } from '@angular/core';
import { PolicyRequestsCommonService, PolicyRequestsData, RenewalsRequestsService } from '@nationwide/dgs-internet-servicing-policy-requests';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { commonConstants } from '../../CONSTANTS/tpi-common-constants';
import { LoggerService } from '../logger/logger.service';
import { PolicySearchResultsAdapterService } from './policy-search-results-adapter.service';
import { Renewal } from '../../tpi-models/general/rewewals';
@Injectable({
    providedIn: 'root'
})
export class RenewalsService {
    renewals: Renewal[];
    private loggerService = inject(LoggerService);
    private policyRequestsCommonService = inject(PolicyRequestsCommonService);
    private policySearchResultsAdapter = inject(PolicySearchResultsAdapterService);
    private renewalsRequestsService = inject(RenewalsRequestsService);

    getPropertyRenewals(policyNumber: string, consumerData: any, propertyOptions: any): Observable<any> {
        const policyRequestsData: PolicyRequestsData = {
            consumerData,
            productType: propertyOptions.propertyType,
            policyId: policyNumber,
            skipCache: propertyOptions.skipCache
        };
        return this.renewalsRequestsService.getAllRenewals(policyRequestsData).pipe(switchMap((propertyRenewalResponse) => {
            this.loggerService.info('Success policy renewel API - getAllRenewals()',
                { policyNumber, propertyRenewalResponse });
            const boundRenewals = propertyRenewalResponse?.length > 0 ? propertyRenewalResponse.filter((renewalInformation) => renewalInformation.status === commonConstants.POLICY_STATUS_BOUND).sort((a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime()) : [];
            this.renewals = boundRenewals;
            const renewalID = boundRenewals[0]?.renewalId;
            if (renewalID) {
                const renewalRequestsData: PolicyRequestsData = {
                    consumerData,
                    productType: propertyOptions.propertyType,
                    policyId: policyNumber,
                    renewalId: renewalID,
                    skipCache: propertyOptions.skipCache
                };
                return this.renewalsRequestsService.getRenewalCoverages(renewalRequestsData).pipe(switchMap((response) => {
                    if (response) {
                        this.loggerService.info('Success policy coverages renewal API - getRenewalCoverages()', { renewalID, response });
                        const renewalInformation = this.policySearchResultsAdapter.mapPropertyEndorsements(response, propertyOptions.propertyType);
                        renewalInformation.renewalEffectiveDate = boundRenewals[0]?.effectiveDate;
                        return of(renewalInformation);
                    } else {
                        this.loggerService.info('Error retreiving responses from renewal API - getRenewalCoverages()', { renewalID, response });
                        return of({});
                    }
                }), catchError((error) => {
                    this.loggerService.error('Error policy coverages renewal API - getRenewalCoverages()', { renewalID, error });
                    return of(error);
                }));
            } else {
                this.loggerService.info('Error retreiving renewal ID - getRenewalCoverages()');
                return of({});
            }
        }),
            catchError((error) => {
                this.loggerService.error('Error policy renewal API - getAllRenewals()', { policyNumber, error });
                return of(error);
            }));
    }
}